var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBinTrashSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0989 5H2.93982",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7105 7.08398L15.3274 12.8332C15.1799 15.0457 15.1062 16.1519 14.3858 16.8262C13.6653 17.5007 12.5573 17.5007 10.3412 17.5007H9.69709C7.48092 17.5007 6.37285 17.5007 5.6524 16.8262C4.93196 16.1519 4.85825 15.0457 4.71083 12.8332L4.32776 7.08398",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93713 9.16602L8.3538 13.3327",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1017 9.16602L11.6851 13.3327",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43848 5C5.48502 5 5.50829 5 5.52939 4.99947C6.21521 4.98208 6.82024 4.54576 7.05361 3.90027C7.06079 3.88041 7.06815 3.85833 7.08287 3.81414L7.16373 3.57142C7.23276 3.36423 7.26727 3.26063 7.31305 3.17267C7.4957 2.82172 7.83362 2.57803 8.22414 2.51564C8.32202 2.5 8.43118 2.5 8.64948 2.5H11.3892C11.6075 2.5 11.7166 2.5 11.8145 2.51564C12.205 2.57803 12.5429 2.82172 12.7256 3.17267C12.7714 3.26063 12.8059 3.36423 12.8749 3.57142L12.9558 3.81414C12.9705 3.85827 12.9779 3.88042 12.985 3.90027C13.2184 4.54576 13.8234 4.98208 14.5093 4.99947C14.5304 5 14.5536 5 14.6002 5",
    stroke: "#FD2233",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinTrashSvgrepoCom1);
export default __webpack_public_path__ + "static/media/trash-bin-trash-svgrepo-com 1.37bc4a2c82b8d2fd8dfc083d195afba1.svg";
export { ForwardRef as ReactComponent };